import { createStore } from 'vuex'
import axios from 'axios'
import * as d3 from 'd3';

export default createStore({
	state: {
		content: [],
		data: [],
		selectedFonds: null
	},
	mutations: {
		SAVE_CONTENT (state, data) {
			// console.log("content:", state.content);
			state.content = data.data;
		},

		SAVE_DATA (state, data) {
			// console.log("data: ", data);
			state.data = data;
		},

		UPDATE_FONDS(state, fonds) {
			state.selectedFonds = fonds;
		}
	},
	getters: {
		// articleItems: state => state.articles
		selectedFonds: state => state.selectedFonds
	},
	actions: {
		loadContent ({commit, state}) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
						commit("SAVE_CONTENT", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			});
		},

		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				d3.csv(process.env.VUE_APP_BASE + '/assets/data/alles.csv')
					.then(result => {
						commit("SAVE_DATA", result);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},

		updateFonds({commit, state}, fonds) {
			commit("UPDATE_FONDS", fonds);
		}
	},
	modules: {

	}
})
